// URL-as-capability: ?trip=<UUID>&legs=<UUID>,<UUID>,...#date=YYYY-MM-DD

export function parseTripUrl(search = window.location.search) {
  const params = new URLSearchParams(search);
  const tripId = params.get("trip");
  const legsParam = params.get("legs");
  const legIds = legsParam
    ? legsParam.split(",").map((s) => s.trim()).filter(Boolean)
    : [];
  return { tripId, legIds };
}

export function buildShareUrl(tripId, legIds, origin = window.location.origin) {
  const params = new URLSearchParams();
  params.set("trip", tripId);
  params.set("legs", legIds.join(","));
  return `${origin}/?${params.toString()}`;
}

export function setTripUrl(tripId, legIds, replace = true) {
  const url = buildShareUrl(tripId, legIds, window.location.origin) + window.location.hash;
  if (replace) {
    window.history.replaceState(null, "", url);
  } else {
    window.history.pushState(null, "", url);
  }
}

export function getDateFromHash(hash = window.location.hash) {
  const m = hash.match(/[#&]date=(\d{4}-\d{2}-\d{2})/);
  return m ? m[1] : null;
}

export function setDateHash(iso) {
  const base = window.location.pathname + window.location.search;
  window.history.replaceState(null, "", iso ? `${base}#date=${iso}` : base);
}

export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch {
      return false;
    }
  }
}
